// Pure pope calculation helpers shared between edge-scripts (Deno) and outlive-site (Vite).
// No runtime-specific imports — safe for both environments.

import type { Pope } from './popeTypes.ts';

export function totalMonthsAtDeath(pope: Pope): number {
  return pope.yearsAtDeath * 12 + pope.monthsAtDeath;
}

// A pope who was only an antipope (never held an official pope number).
export function isPureAntipope(pope: Pope): boolean {
  return pope.antipopeNumber > 0 && pope.popeNumber === 0;
}

export function ageInMonths(date: Date, birthYear: number, birthMonth: number): number {
  return (date.getUTCFullYear() * 12 + date.getUTCMonth() + 1) - (birthYear * 12 + birthMonth);
}

// A pope is outlived when the player's age strictly exceeds their death age.
export function isOutlived(deathAgeMonths: number, playerAgeMonths: number): boolean {
  return deathAgeMonths < playerAgeMonths;
}

// A pope is newly outlived in a window when they were not yet outlived at the start
// (deathAge >= ageAtWindowStart) but are outlived now (deathAge < ageAtWindowEnd).
export function isNewlyOutlived(deathAgeMonths: number, ageAtWindowStart: number, ageAtWindowEnd: number): boolean {
  return deathAgeMonths >= ageAtWindowStart && deathAgeMonths < ageAtWindowEnd;
}
